<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">The Highest Mountain</a></li>
<li><a href="#/Text/Section0004">Dreamer's World</a></li>
<li><span href="#/Text/Section0005" title="Link target outside of Sample">Freeway</span></li>
<li><span href="#/Text/Section0006" title="Link target outside of Sample">The Happy Herd</span></li>
<li><span href="#/Text/Section0007" title="Link target outside of Sample">The Chasm</span></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">The Floater</span></li>
<li><span href="#/Text/Section0009" title="Link target outside of Sample">Dark Windows</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0e0e12b6